<template>
  <MobileContainer>
    <MobileHeader slot="header"
                  nav-action="close">
      Select a Location
    </MobileHeader>
    <RestaurantPicker :next-route-name="nextRouteName" />
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import MobileButton from '@/apps/mobile/components/MobileButton';
import RestaurantPicker from '@/components/RestaurantPicker';

/**
 * Mobile select location screen.
 */
@Component({
  components: {
    MobileButton,
    MobileHeader,
    MobileContainer,
    RestaurantPicker,
  },
  props: {
    nextRouteName: {
      type:     String,
      default:  null,
      required: true,
    },
  },
})
export default class MobileSelectLocation extends Vue {}
</script>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileSelectLocation.vue